import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginPageView from './LoginPageView';

import { useMytaverse } from '@providers/MytaverseProvider';
import { IEventThemeTypes } from '@interfaces';

const LoginPage = () => {
  const { appTheme } = useMytaverse();

  const { t: translate } = useTranslation();

  const isDefaultEvent = appTheme.themeName === IEventThemeTypes.DEFAULT;
  const appThemeTitle = appTheme.loginPage.typography.title;
  const title = isDefaultEvent
    ? translate(appThemeTitle)
    : `${translate('login.welcomeTo')} ${appThemeTitle}`;

  return <LoginPageView title={title} />;
};

export default LoginPage;
